// extracted by mini-css-extract-plugin
module.exports = {"root":"Ad-module--root--3J5GB","wrapperLink":"Ad-module--wrapper-link--28Tkt","slide":"Ad-module--slide--OVCe-","title":"Ad-module--title--qF6Pb"};